import React, { useState } from "react";
import { Grid, IconButton, InputBase } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { SearchOff } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Thread from "./components/Thread";
import { getSelectedThreadId } from "../../store/ui/messageCentre";
import ExpandedThread from "./components/ExpandedThread";
import { getMessageThreads } from "../../store/hub/message";
import NewMessage from "./components/NewMessage";
import { getUsersNamesByIds } from "../../store/hub/users";
import { getTeamsNamesByIds } from "../../store/hub/teams";

export default function MessageCentre() {

  MessageCentre.whyDidYouRender = {
    logOnDifferentValues: false,
    customName: 'MessageCentre'
  }

  const classes = useStyles();
  let threads = useSelector(getMessageThreads)();
  const [searchParam, setSearchParam] = useState(null);
  const getUsersList = useSelector(getUsersNamesByIds);
  const getTeamsList = useSelector(getTeamsNamesByIds);

  const searchThreads = (queryText) => {
    setSearchParam(queryText);
  };

  let selectedThreadId = useSelector(getSelectedThreadId)();
  // When leaving a thread it is possible the thread is removed before the selectedThreadId is updated
  // To display a thread we check both the id and object is present
  let selectedThread = threads.filter((thread) => thread.Id === selectedThreadId)[0];

  return (
    <>
      {selectedThreadId && selectedThread ? (
        <ExpandedThread
          thread={selectedThread}
        />
      ) : (
        <>
          <NewMessage />
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              id="headerSearchBox"
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              onChange={(e) => searchThreads(e.target.value)}
              inputProps={{ "aria-label": "search" }}
            />
            <div className={classes.clearIcon}>
              <IconButton
                size="small"
                onClick={() => {
                  document.getElementById("headerSearchBox").value = "";
                  searchThreads("");
                }}
              >
                <SearchOff />
              </IconButton>
            </div>
          </div>
          <Grid
            container
            spacing={0}
            style={{ overflowY: "scroll", height: "auto" }}
          >
            {threads.length >= 1 &&
              threads
                .slice()
                .sort(
                  (a, b) =>
                    new Date(b.LatestMessage.UtcCreatedDateTime) -
                    new Date(a.LatestMessage.UtcCreatedDateTime)
                )
                .map((thread) => {
                  let userNameSearchParam = "";
                  if (thread.UserIds.length >= 1)
                    userNameSearchParam = getUsersList(thread.UserIds);
                  let teamNameSearchParam = "";
                  if (thread.TeamIds.length >= 1)
                    teamNameSearchParam = getTeamsList(thread.TeamIds);

                  if (
                    (searchParam &&
                      thread.DisplayName &&
                      thread.DisplayName.toLowerCase().includes(
                        searchParam.toLowerCase()
                      )) ||
                    (searchParam &&
                      userNameSearchParam &&
                      userNameSearchParam
                        .toLowerCase()
                        .includes(searchParam.toLowerCase())) ||
                    (searchParam &&
                      teamNameSearchParam &&
                      teamNameSearchParam
                        .toLowerCase()
                        .includes(searchParam.toLowerCase())) ||
                    !searchParam
                  )
                    if (thread.Display)
                      return (
                        <Thread
                          thread={thread}
                          key={"messageThread" + thread.Id}
                        />
                      );

                  return null;
                })}
          </Grid>
        </>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#eee",
    color: "#000",
    "&:hover": {
      backgroundColor: "#e2e2e2",
    },
    margin: theme.spacing(1),
    width: "auto",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
  },
  clearIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    top: 0,
    color: "rgba(0, 0, 0, 0.54)",
  },
  inputRoot: {
    color: "#000",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    paddingRight: 40,
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    width: "100%",
    color: "#000",
    "&::placeholder": {
      color: "#757575",
      opacity: 1,
    },
  },
}));
